const BoxHeader = ({ text }) => {
  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <h5 style={{ marginTop: "10px", marginBottom: "5px" }}>{text}</h5>
    </div>
  );
};

export default BoxHeader;
